import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import { IconDelete } from '../../../../../../../data/assets/icons';

import InputItem from '../../../../../../../components/form/inputitem';
import AddInputItem from '../../../../../../../components/form/addinputItem';

class CannedResponseForm extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            new_message: "",
            show_subheading: props.canned_response.subHeading && props.canned_response.subHeading.length > 0
        };
    }

    showSubHeading = () => {
        this.setState({ show_subheading: true });
    };

    hideSubHeading = () => {
        this.setState({ show_subheading: false });
        this.props.onChange('subHeading', "");
    };

    handleChange = e => {
        if (e.target.name) {
            const key = e.target.name;
            const value = e.target.value;
            this.props.onChange(key, value);
        }
    };

    onChangeMessage = e => {
        this.setState({
            new_message: e.target.value
        })
    };

    onClickBtn = () => {
        const { new_message } = this.state;
        if (new_message.trim().length > 0) {
            this.props.addNewMessage(new_message.trim());
            this.setState({ new_message: "" });
        }
    };

    onKeyDown = e => {
        if (e.keyCode === 13 && !e.shiftKey) {
            this.onClickBtn();
            e.preventDefault();
        }
    };

    renderSubHeading = () => {
        const { canned_response } = this.props;
        const { show_subheading } = this.state;
        if (show_subheading) {
            return (
                <React.Fragment>
                    <div className="ori-font-danger ori-cursor-ptr" onClick={this.hideSubHeading}>
                        <Icon type="close-circle" className="ori-font-sm" />
                        <span className="ori-l-pad-5 ori-font-13">remove subheading</span>
                    </div>
                    <InputItem container_class="ori-b-pad-10 ori-b-mrgn-5" title="Subheading" name="subHeading" placeholder="Enter one word subheading" value={canned_response.subHeading} message={canned_response.heading && canned_response.heading.trim().length > 0 ? "" : "heading is required to add subheading"} onChange={this.handleChange} />
                </React.Fragment>
            );
        }
        return (
            <div className="ori-b-pad-5 ori-font-primary ori-cursor-ptr" onClick={this.showSubHeading}>
                <Icon type="plus-circle" className="ori-font-sm" />
                <span className="ori-l-pad-5 ori-font-13">Add subheading</span>
            </div>
        );
    }

    render() {
        const { canned_response, onClickDeleteMessage } = this.props;
        const { new_message } = this.state;
        return (
            <div className="ori-pad-15">
                <InputItem title="Shortcut" name="shortcut" placeholder="Enter one word shortcut key" value={canned_response.shortcut} onChange={this.handleChange} />
                <p className="ori-font-xs ori-font-light">To use a canned response during a chat, type in # and a shortcut.</p>
                <InputItem title="Heading" name="heading" placeholder="Enter one word heading" value={canned_response.heading} onChange={this.handleChange} />
                {this.renderSubHeading()}
                <AddInputItem input_type="textarea" title="Canned responses" placeholder="Enter new message and press enter" value={new_message} show_add_btn={new_message.trim().length > 0} onChange={this.onChangeMessage} onClickBtn={this.onClickBtn} onKeyDown={this.onKeyDown} />
                <p className="ori-font-xs ori-font-light ori-b-mrgn-15" >Canned responses are pre-made messages you can recall easily during chat</p>
                {
                    canned_response.messages && canned_response.messages.length > 0 &&
                    canned_response.messages.map((message, index) => {
                        return (
                            <div key={index} className="ori-relative ori-animated ori-fade-in ori-l-pad-10 ori-tb-pad-10 ori-r-pad-30 ori-bg-default ori-border-light ori-border-radius-4 ori-font-xs ori-b-mrgn-10">
                                {message}
                                <div className="ori-absolute ori-align-right ori-align-top ori-font-light-hover-primary ori-pad-10" onClick={onClickDeleteMessage.bind(this, index)}>
                                    <IconDelete size={16} />
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

CannedResponseForm.propTypes = {
    canned_response: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    addNewMessage: PropTypes.func,
    onClickDeleteMessage: PropTypes.func,
};

CannedResponseForm.defaultProps = {
    canned_response: {},
    onClickDeleteMessage: () => { },
};

export default CannedResponseForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/cannedresponses/components/cannedresponseform/index.js